import axios from "axios";
import {
  SUPPLIER_LIST_REQUEST,
  SUPPLIER_LIST_SUCCESS,
  SUPPLIER_LIST_FAIL,
  SUPPLIER_SINGLE_REQUEST,
  SUPPLIER_SINGLE_SUCCESS,
  SUPPLIER_SINGLE_FAIL,
  POST_SUPPLIER_REQUEST,
  POST_SUPPLIER_SUCCESS,
  POST_SUPPLIER_FAIL,
  UPDATE_SUPPLIER_REQUEST,
  UPDATE_SUPPLIER_SUCCESS,
  UPDATE_SUPPLIER_FAIL,
  DELETE_SUPPLIER_REQUEST,
  DELETE_SUPPLIER_SUCCESS,
  DELETE_SUPPLIER_FAIL,
} from "constants/supplierConstants";
import SuppliersService from "services/suppliers-service";

export const getSupplierList = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: SUPPLIER_LIST_REQUEST,
    });

    const res = await SuppliersService.getSuppliers();
    console.log(
      "🚀 ~ file: supplierActions.js:26 ~ getSupplierList ~ res:",
      res
    );

    dispatch({
      type: SUPPLIER_LIST_SUCCESS,
      payload: res.foundSuppliers,
    });
  } catch (error) {
    console.log(
      "🚀 ~ file: supplierActions.js:36 ~ getSupplierList ~ error:",
      error
    );
    dispatch({
      type: SUPPLIER_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const getSupplierSingle = (supplierId) => async (dispatch, getState) => {
  console.log(
    "🚀 ~ file: supplierActions.js:45 ~ getSingleSupplier ~ supplierId:",
    supplierId
  );
  try {
    dispatch({
      type: SUPPLIER_SINGLE_REQUEST,
    });

    const res = await SuppliersService.getSingleSupplier(supplierId);
    console.log(
      "🚀 ~ file: supplierActions.js:51 ~ getSingleSupplier ~ res:",
      res
    );

    dispatch({
      type: SUPPLIER_SINGLE_SUCCESS,
      payload: res.foundSupplier,
    });
  } catch (error) {
    console.log(
      "🚀 ~ file: supplierActions.js:67 ~ getSupplierSingle ~ error:",
      error
    );
    dispatch({
      type: SUPPLIER_SINGLE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const createSupplier = (supplier) => async (dispatch, getState) => {
  try {
    dispatch({
      type: POST_SUPPLIER_REQUEST,
    });

    const res = await SuppliersService.createNewSupplier(supplier);
    console.log("🚀 ~ file: supplierActions.js:26 ~ postSupplier ~ res:", res);

    dispatch(getSupplierList());

    dispatch({
      type: POST_SUPPLIER_SUCCESS,
      payload: res,
    });
  } catch (error) {
    console.log(
      "🚀 ~ file: supplierActions.js:95 ~ createSupplier ~ error:",
      error
    );
    dispatch({
      type: POST_SUPPLIER_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const supplierUpdating =
  (supplierId, supplier) => async (dispatch, getState) => {
    try {
      dispatch({
        type: UPDATE_SUPPLIER_REQUEST,
      });

      const res = await SuppliersService.updateSupplier(supplierId, supplier);
      console.log(
        "🚀 ~ file: supplierActions.js:26 ~ updateSupplier ~ res:",
        res
      );
      dispatch(getSupplierSingle(supplierId));
      dispatch(getSupplierList());

      dispatch({
        type: UPDATE_SUPPLIER_SUCCESS,
        payload: res,
      });
    } catch (error) {
      console.log("🚀 ~ file: supplierActions.js:135 ~ error:", error);
      dispatch({
        type: UPDATE_SUPPLIER_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };

export const supplierDeleting = (supplierId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: DELETE_SUPPLIER_REQUEST,
    });

    const res = await SuppliersService.deleteSupplier(supplierId);
    console.log(
      "🚀 ~ file: supplierActions.js:26 ~ deleteSupplier ~ res:",
      res
    );

    dispatch({
      type: DELETE_SUPPLIER_SUCCESS,
      payload: res,
    });
  } catch (error) {
    dispatch({
      type: DELETE_SUPPLIER_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};
